export default {
  BASE_URL: "https://production.investpersonally.com/",
};
